import { render, staticRenderFns } from "./CaritasColabora.vue?vue&type=template&id=b9583346&scoped=true"
import script from "./CaritasColabora.vue?vue&type=script&lang=js"
export * from "./CaritasColabora.vue?vue&type=script&lang=js"
import style0 from "./CaritasColabora.vue?vue&type=style&index=0&id=b9583346&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9583346",
  null
  
)

export default component.exports